import React, { memo } from "react";

import { AdminConsoleTabs } from "Components/AdminConsole/AdminConsoleTabs";
import { AuditHistory } from "Components/AdminConsole/AuditHistory";
import {
  AdminConsoleBodyStyled,
  AdminPageStyled,
} from "Components/AdminConsole/styles";

export const AuditHistoryPage = memo(() => (
  <AdminPageStyled data-test-id="admin_page">
    <AdminConsoleTabs active="history" />
    <AdminConsoleBodyStyled data-test-id="admin_console_body">
      <AuditHistory />
    </AdminConsoleBodyStyled>
  </AdminPageStyled>
));
